import {
  DensityLotShortName,
  DensityLotDate,
  DensityLotId,
} from '../../filenameTemplateItems/instances/density'
import {
  densities,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SimpleReportItem } from '../classes/SimpleReportItem'

export const DensityLot = new SimpleReportItem({
  id: 'C0542EB2-C57F-493B-A895-92012B059DC3',
  name: 'Density Lot',
  classType: 'Lot',
  classTypeName: 'Density Lot',
  endpoint: 'lots',
  queryParameter: 'density-lot',
  label: 'lotId',
  sampleFilename: 'density-lot',
  afterClientProjectNumber: [
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: DensityLotShortName.id },
    { type: 'custom', text: '_DENSITY_' },
    { type: 'templateItem', templateItemId: DensityLotDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: DensityLotId.id },
  ],
  compatibleTemplateItems: [...projects, ...densities],
  key: 'globalId',
})
